import React, { Component } from "react";
import { Link } from "react-router-dom";
import arrowRight from "../img/right-arrow.svg";
import arrowLeft from "../img/left-arrow.svg";
import deliverScreen from "../img/ecommerce/delivery.png";
import tajamScreen from "../img/landing/tajam.png";

export default class Work extends Component {
  render() {
    return (
      <div className="work">
        <div className="title">
          <div className="title__img">
            <img src={arrowLeft} height="25px" alt="arrow right" />
          </div>
          <div className="title__heading">
            <h1>My works</h1>
          </div>
          <div className="title__img">
            <img src={arrowRight} height="25px" alt="arrow right" />
          </div>
        </div>
        <div className="work__content work-content">
          <div className="work-content__item">
            <div className="work-content__heading">Landing page websites</div>
            <Link to="/landing" className="work-content__link">
              <img src={tajamScreen} alt="" />
            </Link>
          </div>
          <div className="work-content__item">
            <div className="work-content__heading">E-commerce websites</div>
            <Link to="/ecommerce" className="work-content__link">
              <img src={deliverScreen} alt="" />
            </Link>
          </div>
        </div>
      </div>
    );
  }
}
